<form (submit)="reportForm.valid && onSubmit()" [formGroup]="reportForm" method="POST" ngNativeValidate>
<div class="modal-header">
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
    <h4 class="modal-title"> Report Link</h4>
</div>
<div class="modal-body">
    <div class="form-group">
        <label  for="subject">Report reason<span class="required"></span></label>
        <select required
            class="form-control required"
            name="subject"
            formControlName="subject"
        >
            <option value="">-- Please select --</option>
            <option value="Infringes on the copyright of someone I am authorized to represent">Infringes on the copyright of someone I am authorized to represent</option>
            <option value="Contains malicious content">Contains malicious content</option>
        </select>
    </div>
    <div class="row">
        <div class="form-group col-md-6">
            <label for="name">Full Name<span class="required">*</span></label>
            <input type="text" required class="form-control required" formControlName="name">
        </div>
        <div class="form-group col-md-6">
            <label  for="email">Your email address<span class="required">*</span></label>
            <input type="text" required class="form-control required email" formControlName="email">
        </div>
    </div>
    <div style="border: none!important;" formGroupName="copyright" *ngIf="reportForm.get('subject').value == 'Infringes on the copyright of someone I am authorized to represent'">
        <div class="row">
            <div class="form-group col-md-6">
                <label for="name">I am reporting on behalf of<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="behalfof" placeholder="The copyright owner" />
            </div>
            <div class="form-group col-md-6">
                <label  for="address">Address<span class="required">*</span></label>
                <input type="text" required class="form-control required"  formControlName="address" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="jobtitle">Job title<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="jobtitle" />
            </div>
            <div class="form-group col-md-6">
                <label  for="city">City<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="city" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="phone">Phone<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="phone" />
            </div>
            <div class="form-group col-md-6">
                <label  for="province">State/Province<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="province"/>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="name">Fax</label>
                <input type="text" class="form-control" formControlName="fax">
            </div>
            <div class="form-group col-md-6">
                <label  for="postalcode">ZIP/Postal Code<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="postalcode">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label  for="linkID">Link Identifier<span class="required">*</span></label>
                <input type="text" readonly class="form-control" [value]="linkID">
            </div>
            <div class="form-group col-md-6">
                <label  for="country">Country<span class="required">*</span></label>
                <input type="text" required class="form-control required" formControlName="country">
            </div>
        </div>

        <p><strong>
            By checking the following boxes, I state UNDER PENALTY OF PERJURY of law that:
        </strong></p>

        <div class="checkbox">
            <label>
                <input type="checkbox" formControlName="dmca1" required value="1">
            I hereby state that I have a good faith belief that the sharing of copyrighted material at the location above is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use).
            </label>
        </div>
        <div class="checkbox">
            <label>
                <input type="checkbox" formControlName="dmca2" required  value="1">
                I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of, the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.
            </label>
        </div>
        <div class="checkbox">
            <label>
                <input type="checkbox" formControlName="dmca3" required value="1">
                I acknowledge that any person who knowingly materially misrepresents that material or activity is infringing may be subject to liability for damages.
            </label>
        </div>
    </div>
    <div class="row">
        <div class="form-group   col-md-offset-2 col-md-8">
            <label class="control-label" for="comments">Additional comments</label>
            <textarea class="form-control" id="comments" formControlName="description" rows="4"></textarea>
        </div>
    </div>
    <div class="row ">
        <div class="form-group col-md-offset-2 col-md-8">
            Typing your full name in this box will act as your digital signature
            <input type="text" required class="form-control required" formControlName="digitalsignature" />
        </div>
    </div>
</div>
        
<div class="modal-footer text-right">
    <button type="button" class="btn btn-default" (click)="activeModal.close()">Cancel</button>
    <button type="submit"
        class="btn btn-primary"
        [disabled]="!reportForm.valid">Submit</button>
</div>
</form>
        